import React, { useState, useEffect } from 'react';

import ico_file from '../../../../assets/ico/ico_file.svg';
import ico_bbox from '../../../../assets/ico/ico_bbox.svg';
import ico_bbox_check from '../../../../assets/ico/ico_bbox_check.svg';

const FileGroup = ({ file_group, index_group, files, capacity, file_Update_Params }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [isParamsOpen, setParamsIsOpen] = useState(null);
    const [currentParams, setCurrentParams] = useState({
        label: "",
        georefs: [
            {
                bbox: null,
                page: "1"
            }
        ]
    })

    const params_open = (doc_name, file) => {
        var new_currentParams = file?.params || {
            label: "",
            georefs: [
                {
                    bbox: null,
                    page: "1"
                }
            ]
        };
        setCurrentParams(new_currentParams);
        setParamsIsOpen(doc_name);
    }
    const params_close = (file) => {
        if (file.name === isParamsOpen) {
            var var_currentParams = JSON.parse(JSON.stringify(currentParams));
            console.log("var_currentParams", var_currentParams, file);
            // CHECK ALL VALIDITY
            var validity_all = true;
            // CHECK LABEL VALIDITY
            var validity_label = true;
            if (var_currentParams.label === "") { validity_label = false }
            // CHECK BBOX VALIDIDTY
            var validity_bbox = true;
            var new_bbox = var_currentParams.georefs[0].bbox;
            if (new_bbox === "" || new_bbox === null) {
                validity_bbox = false;
            }
            else {
                // Check if value is valid
                if (new_bbox[0] !== "[") { validity_bbox = false }
                if (new_bbox[new_bbox.length - 1] !== "]") { validity_bbox = false }
                try {
                    var new_bbow_json = JSON.parse(new_bbox);
                    if (new_bbow_json.length !== 4) { validity_bbox = false }
                    if (typeof (new_bbow_json[0]) !== "number") { validity_bbox = false }
                    if (typeof (new_bbow_json[1]) !== "number") { validity_bbox = false }
                    if (typeof (new_bbow_json[2]) !== "number") { validity_bbox = false }
                    if (typeof (new_bbow_json[3]) !== "number") { validity_bbox = false }
                } catch (error) {
                    console.log("ERROR", error);
                    validity_bbox = false;
                }
            }
            // CHECK PAGE VALIDITY
            var validity_page = true;
            if (var_currentParams.georefs[0].page === "" || var_currentParams.georefs[0].page < 1) { validity_page = false }



            // Check if valid
            if (validity_label === false || validity_bbox === false || validity_page === false) {
                console.log("PARAMS NOT VALID", validity_label, validity_bbox, validity_page);
            }
            // Check if different
            else if (file?.params && (file.params?.label === var_currentParams.label && file.params.georefs[0]?.bbox === var_currentParams.georefs[0].bbox && file.params.georefs[0]?.page === var_currentParams.georefs[0].page)) {
                console.log("PARAMS NOT CHANGED");
            }
            else {
                file_Update_Params(file, var_currentParams);
            }
        }
        setParamsIsOpen(null);
    }

    const params_leave = (file) => {
        params_close(file);
    }

    const handleChange_Label = (new_label) => {
        var var_currentParams = JSON.parse(JSON.stringify(currentParams));
        var_currentParams.label = new_label;
        setCurrentParams(var_currentParams);
    }
    const handleChange_Bbox = (new_bbox) => {
        var var_currentParams = JSON.parse(JSON.stringify(currentParams));
        var_currentParams.georefs[0].bbox = new_bbox;
        setCurrentParams(var_currentParams);

        // var new_bbox_val = null;
        // if (new_bbox === "") {
        //     console.log("EMPTY");
        //     new_bbox_val = null;
        //     var_currentParams.georefs[0].bbox = new_bbox_val;
        // }
        // else {
        //     // Check if value is valid
        //     var validity = true;
        //     if (new_bbox[0] !== "[") { validity = false }
        //     if (new_bbox[new_bbox.length - 1] !== "]") { validity = false }
        //     try {
        //         var new_bbow_json = JSON.parse(new_bbox);
        //         console.log("JSON", new_bbow_json, new_bbow_json.length);
        //         if (new_bbow_json.length !== 4) { validity = false }
        //         if (typeof (new_bbow_json[0]) !== "number") { validity = false }
        //         if (typeof (new_bbow_json[1]) !== "number") { validity = false }
        //         if (typeof (new_bbow_json[2]) !== "number") { validity = false }
        //         if (typeof (new_bbow_json[3]) !== "number") { validity = false }
        //     } catch (error) {
        //         console.log("ERROR", error);
        //         validity = false;
        //     }

        //     if (validity === true) {
        //         new_bbox_val = JSON.parse(new_bbox);
        //         console.log("BBOX VALID");
        //     }
        //     else {
        //         console.log("BBOX INVALID");
        //         new_bbox_val = null;
        //     }
        //     var_currentParams.georefs[0].bbox = new_bbox_val;
        // }
        // setCurrentParams(var_currentParams);
    }
    const handleChange_Page = (new_page) => {
        var var_currentParams = JSON.parse(JSON.stringify(currentParams));
        var_currentParams.georefs[0].page = new_page;
        setCurrentParams(var_currentParams);
    }


    useEffect(() => {
        // console.log("UPDATED PARAMS", currentParams);
    }, [currentParams]);

    return (
        <div className="app__ruleset_group_container">
            <div className="app__ruleset_group_header" onClick={() => { setIsOpen(!isOpen) }}>
                <div className={`app__ruleset_group__header_ico ${isOpen ? "app__ruleset_group__header_ico_open" : ""}`}>&gt;</div>
                <div>{file_group}</div>
            </div>
            <div className={`app__ruleset_group ${isOpen ? "app__ruleset_group_open" : ""}`}>
                {Array.isArray(files[file_group]) ?
                    files[file_group].map((file, index_file) => {
                        return (
                            <div key={index_group + "_" + index_file}>
                                <div className="app__ruleset_file_container">
                                    <a href={file.url} target="_blank">
                                        <div className="app__ruleset_ico"><img src={ico_file} alt="ico_file" /></div>
                                    </a>
                                    <a href={file.url} target="_blank">
                                        <div className="app__bound_body_value">{file.title}</div>
                                    </a>
                                </div>
                            </div>
                        )
                    })
                    :
                    Object.keys(files[file_group]).map(key => {
                        return (
                            <>
                                <div key={"fileGroup" + key} className="app__ruleset_file_container" style={{ marginTop: '4px' }}>
                                    <div className="app__bound_body_value">{key}</div>
                                </div>
                                {files[file_group][key].map((file, index_file) => {
                                    return (
                                        <div key={index_group + "_" + index_file}>
                                            <div className="app__ruleset_file_container2" onMouseLeave={() => { params_leave(file) }}>
                                                <div className={`app__ruleset_file_box ${isParamsOpen === file.name ? "app__ruleset_file_box_opened" : ""}`}>
                                                    <div className="app__ruleset_file_subbox_left">
                                                        <a href={file.url} target="_blank">
                                                            <div className="app__ruleset_ico"><img src={ico_file} alt="ico_file" /></div>
                                                        </a>
                                                        <a href={file.url} target="_blank">
                                                            <div className="app__bound_body_value">{file.title}</div>
                                                        </a>
                                                    </div>
                                                    {/* DOC PARAMS */}
                                                    {capacity?.isModel === true &&
                                                        <div className={`app__ruleset_file_subbox_right ${isParamsOpen === file.name ? "app__ruleset_file_subbox_right_opened" : ""} ${file?.params?.label ? "app__ruleset_file_subbox_right_checked" : ""}`} onClick={() => { params_open(file.name, file) }}>
                                                            <div className="app__ruleset_ico"><img src={file?.params?.label ? ico_bbox_check : ico_bbox} alt="ico_bbox" /></div>
                                                        </div>
                                                    }
                                                    {isParamsOpen === file.name &&
                                                        <div className="app__ruleset_file_params_container scale-up-top">
                                                            <div className="app__ruleset_file_params_group">
                                                                <div className="app__ruleset_file_params_title">Label</div>
                                                                <input className="app__ruleset_file_params_input_number" type="text" placeholder="Label du document géoréférencé" id={file.name + "input_label"} name={file.name + "input_label"} onChange={(e) => { handleChange_Label(e.target.value) }} defaultValue={currentParams.label} />
                                                            </div>
                                                            <div className="app__ruleset_file_params_row">
                                                                <div className="app__ruleset_file_params_group">
                                                                    <div className="app__ruleset_file_params_title">Bbox(BLTR)</div>
                                                                    <input className="app__ruleset_file_params_input_number" type="text" placeholder="Liste des 4 points" id={file.name + "input_bbox"} name={file.name + "input_bbox"} onChange={(e) => { handleChange_Bbox(e.target.value) }} defaultValue={currentParams.georefs[0].bbox} />
                                                                    {/* <input className="app__ruleset_file_params_input_number" type="number" id={file.name + "input_bbox_bl"} name={file.name + "input_bbox_bl"} min="-100" max="100" step="0.0000001" onChange={(e) => { handleChange_Bbox(e.target.value) }} defaultValue={currentParams.georefs[0].bbox}></input> */}
                                                                </div>
                                                                {/* <div className="app__ruleset_file_params_group">
                                                                    <div className="app__ruleset_file_params_title">Bbox(TR)</div>
                                                                    <input className="app__ruleset_file_params_input_number" type="number" id={file.name + "input_bbox_tr"} name={file.name + "input_bbox_tr"} min="-100" max="100" step="0.0000001" onChange={(e) => { handleChange_BboxTR(e.target.value) }} defaultValue={currentParams.georefs[0].bbox_tr}></input>
                                                                </div> */}
                                                                <div className="app__ruleset_file_params_group" style={{ maxWidth: '130px' }} >
                                                                    <div className="app__ruleset_file_params_title">Page</div>
                                                                    <input className="app__ruleset_file_params_input_number" style={{ maxWidth: '100px' }} type="number" id={file.name + "input_page"} name={file.name + "input_page"} min="1" step="1" onChange={(e) => { handleChange_Page(e.target.value) }} defaultValue={currentParams.georefs[0].page}></input>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default FileGroup;